import { jsx as _jsx } from "react/jsx-runtime";
import { Grid } from "@mui/material";
import Link from "@mui/material/Link";
export const ProductLinks = ({ product }) => {
    return product.links
        ?
            _jsx(Grid, { item: true, xs: 12, children: _jsx(Grid, { container: true, children: product.links.map((link, index) => _jsx(Grid, { item: true, xs: 12, sx: { padding: '2px', overflowX: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', color: '#2164a9' }, children: _jsx(Link, { href: link.uri, target: '_blank', title: "Go to source", children: link.text }, void 0) }, index)) }, void 0) }, void 0)
        : null;
};
//# sourceMappingURL=ProductLinks.js.map